import React, { useState } from 'react';

const titleStyle = {
  fontFamily: "'Fraunces', Georgia, serif",
  fontSize: 22,
  fontWeight: 600,
  color: '#1f2a2e',
  margin: 0,
  letterSpacing: '-0.01em',
};

const subtitleStyle = {
  margin: '6px 0 16px',
  paddingRight: 50,
  fontSize: 15,
  color: '#6f6a5f',
  lineHeight: 1.55,
};

export default function CollapsibleSection({ title, subtitle, defaultOpen = false, children }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section style={{ marginTop: 28 }}>
      <button
        onClick={() => setOpen(v => !v)}
        style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          width: '100%', padding: 0, background: 'none', border: 'none',
          cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
        }}
      >
        <h2 style={titleStyle}>{title}</h2>
        <span style={{
          fontSize: 16, color: '#8b8475', display: 'inline-block', flexShrink: 0, marginLeft: 12,
          transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s',
        }}>▾</span>
      </button>
      {open && (
        <>
          <p style={subtitleStyle}>{subtitle}</p>
          {children}
        </>
      )}
    </section>
  );
}
